<template>
    <v-container>
        <v-tabs v-model="tab">
            <v-tab>Datos personales</v-tab>
            <v-tab>Datos de contabilidad</v-tab>
            <v-tab v-if="user.id != null">Incidencias</v-tab>
            <v-tab v-if="user.id != null">Vacaciones</v-tab>
            <slot name="tab-headers"></slot>
            <v-tab-item>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.name"
                            label="Nombre y apellidos"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" v-if="!agente">
                        <v-autocomplete
                            v-model="user.idRol"
                            :items="roles"
                            item-text="descripcion"
                            item-value="id"
                            label="Roles"
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.dni"
                            label="DNI"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.email"
                            label="Email de trabajo (credenciales de ingreso)"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.email_trabajo"
                            label="Email personal"
                            required
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.telefono_personal"
                            label="Teléfono personal"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.telefono_comercial"
                            label="Teléfono de trabajo"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.nro_hijos"
                            type="number"
                            label="Nº de hijos"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            label="Estado civil"
                            :items="estados_civiles"
                            v-model="user.id_estado_civil"
                            item-text="nombre"
                            item-value="id"
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.estudios"
                            label="Nivel de estudios"
                            required
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <date-select
                            label="Fecha de nacimiento"
                            v-model="user.fecha_nacimiento"
                        ></date-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.lugar_nacimiento"
                            label="Lugar de nacimiento"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <h4>Dirección</h4>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.direccion.calle"
                            label="Dirección"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.direccion.localidad"
                            label="Localidad"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.direccion.cp"
                            type="number"
                            label="Código postal"
                            required
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-autocomplete
                            v-model="user.direccion.idProvincia"
                            :items="provincias"
                            item-text="nombre"
                            item-value="id"
                            label="Provincias"
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            v-model="user.direccion.id_pais"
                            :items="paises"
                            item-text="nombre"
                            item-value="id"
                            label="País"
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                        <h4>Datos laborales</h4>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            label="Puesto de trabajo"
                            v-model="user.puesto_trabajo"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            label="Equipo"
                            :items="equipos"
                            v-model="user.id_equipo"
                            item-value="id"
                            item-text="nombre"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            label="Cuenta bancaria"
                            v-model="user.cuenta_bancaria"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <h4>Contrato</h4>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            label="Empresa"
                            :items="sociedades"
                            v-model="user.id_empresa"
                            item-value="id"
                            item-text="nombre"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="4">
                        <date-select
                            label="Fecha de alta"
                            v-model="user.fecha_alta"
                        ></date-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <date-select
                            label="Tipo de contrato 1 desde"
                            v-model="user.fecha_contrato_1"
                        ></date-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <date-select
                            label="Tipo de contrato 2 desde"
                            v-model="user.fecha_contrato_2"
                        ></date-select>
                    </v-col>
                    <v-col cols="12" md="4">
                        <date-select
                            label="Fecha de baja"
                            v-model="user.fecha_baja"
                        ></date-select>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            label="Observaciones"
                            v-model="user.observaciones"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.sueldo"
                            type="number"
                            label="Sueldo"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.seg_social"
                            label="Seguridad social a cargo del trabajador"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.empresa"
                            label="Seguridad social a cargo de la empresa"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.trabajador"
                            label="Trabajador"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.irpf"
                            label="IRPF"
                            required
                        ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.jornada"
                            label="Jornada semanal (horas)"
                            required
                        ></v-text-field>
                    </v-col> -->
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.hora"
                            label="Precio de la hora normal"
                            required
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.hora_extra"
                            label="Precio de la hora nocturna"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.precio_km"
                            label="Precio Km"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-divider />
                        <h5 class="mt-3">Jornada laboral</h5>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.horas_jornada_lunes"
                            label="Horas de la jornada de Lunes"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.horas_jornada_martes"
                            label="Horas de la jornada de Martes"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.horas_jornada_miercoles"
                            label="Horas de la jornada de Miércoles"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.horas_jornada_jueves"
                            label="Horas de la jornada de Jueves"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.horas_jornada_viernes"
                            label="Horas de la jornada de Viernes"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.horas_jornada_sabado"
                            label="Horas de la jornada de Sábado"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.horas_jornada_domingo"
                            label="Horas de la jornada de Domingo"
                            required
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item v-if="user.id != null"
                ><TabIncidencia :usuario="user"></TabIncidencia>
            </v-tab-item>
            <v-tab-item>
                <Vacaciones :user="user"></Vacaciones>
            </v-tab-item>
            <slot name="tab-items"></slot>
        </v-tabs>
    </v-container>
</template>
<script>
import TabIncidencia from "./TabIncidencia.vue";
import Vacaciones from "./Vacaciones.vue";
export default {
    props: ["value", "agente"],
    components: {
        TabIncidencia,
        Vacaciones,
    },
    data() {
        return {
            tab: 0,
            provincias: [],
            paises: [],
            estados_civiles: [],
            equipos: [],
            sociedades: [],
            user: { direccion: {} },
        };
    },
    mounted() {
        this.user = this.value;
        this.getPaises();
        this.getEstadosCiviles();
        this.getProvincias();
        this.getEquipos();
        this.getSociedades();
    },
    methods: {
        getSociedades() {
            axios.get(`api/get-sociedades`).then(
                (res) => {
                    this.sociedades = res.data;
                },
                (err) => {
                    this.$custom_error("Error consultando sociedades");
                }
            );
        },
        getProvincias() {
            axios.get(`api/getprovincias`).then(
                (res) => {
                    this.provincias = res.data;
                },
                (res) => {}
            );
        },
        getEquipos() {
            axios.get(`api/get-equipos`).then(
                (res) => {
                    this.equipos = res.data;
                },
                (res) => {}
            );
        },
        getEstadosCiviles() {
            axios.get(`api/estado-civiles`).then(
                (res) => {
                    this.estados_civiles = res.data;
                },
                (res) => {}
            );
        },
        getPaises() {
            axios.get(`api/get-paises`).then(
                (res) => {
                    this.paises = res.data;
                },
                (res) => {}
            );
        },
    },
    watch: {
        value(val) {
            this.user = this.value;
        },
        user: {
            deep: true,
            handler() {
                if (this.user.direccion == null) {
                    this.user.direccion = {};
                }
                this.$emit("input", this.user);
            },
        },
    },
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        roles() {
            return this.$store.getters.getroles;
        },
    },
};
</script>
